<template>
  <el-dialog title="提示"
             :visible.sync="dialogVisible"
             width="50%">
    <el-row>
      <div class="tag-panel">
        <el-button size="small"
                   class="button-new-tag "
                   @click="selectTask">+ 关联任务</el-button>
        <el-tag closable
                class="task-tag"
                effect="plain"
                type="info"
                @close="removeRelations"
                v-for="(item,index) in relations"
                :key="index">({{item.RELATIONINSTANCE}}){{item.NAME}}</el-tag>
        <taskDialog ref="taskDialog"
                    @getValue="getTask"></taskDialog>

      </div>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

</template>
//工作记录或者任务 添加关联任务组件
<script>
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
export default {
  components: {
    taskDialog
  },
  props: {
    outRelation: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialogVisible: false,
      relations: []
    };
  },
  watch: {
    outRelation(newValue) {
      this.relations = newValue;
    }
  },
  methods: {
    getValue() {
      return this.relations;
    },
    selectTask() {
      this.$refs.taskDialog.dialogVisible = true;
    },
    removeRelations(val) {
      this.relations.splice(this.relations.indexOf(val), 1);
    },
    getTask(arr) {
      if (arr.length > 0) {
        console.log(arr);
        let newRelations = arr
          .filter(val => {
            console.log(this.relations.map(r => r.RELATIONID).indexOf(val.ID));
            return this.relations.map(r => r.RELATIONID).indexOf(val.ID) === -1;
          })
          .map(item => {
            return {
              RELATIONID: item.ID,
              RECORDID: this.recordId,
              RELATIONTYPE: 0,
              RELATIONINSTANCE: item.INSTANCE,
              NAME: item.TASKNAME
            };
          });
        this.relations = this.relations.concat(newRelations);
        console.log(this.relations);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.tag-panel {
  margin-left: 120px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.task-tag {
  margin-top: 5px;
  margin-left: 10px;
}
</style>